/** Returns a filled value with a dash prefix. */
export const toTailDashed = (/** @type {string} */ value) => value ? value + '-' : '';
